import React from "react";
import { css } from "@emotion/react";
import {
  breakpointMobileExtended,
  breakpointMobileExtendedPixels,
} from "src/design-system/styles/breakpoints";

import backgroundMobile from "./images/background-mobile.webp";
import backgroundMobileHM from "./images/background-mobile-hm.webp";
import bg from "./images/background.webp";
import backgroundMobileIntl from "./images/background-mobile-intl.webp";
import bgIntl from "./images/background-intl.webp";
import { isIntl } from "src/utils/userSegment";
import { isHolidayPromotion } from "src/utils/holidayPromo";

type BackgroundProps = {
  shouldUseSmallMobileBG: boolean;
};

const backgroundImageStyles = css`
  width: 47%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  right: 0;
  bottom: 0;
  border-top-left-radius: 100px;

  @media ${breakpointMobileExtended} {
    position: relative;
    height: auto;
    width: 100%;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 65px;
  }
`;

export function IntroBackground({ shouldUseSmallMobileBG }: BackgroundProps) {
  /*
    NOTE: When changing the background image you must also change the aspect-ratio property too.

    Adding this property allows us to "reserve space" for the background image which is especially important for our landing page
    on mobile devices. Since the width of the image is 100% of the viewport, the aspect-ratio can be be used to determine the height of the image
    before it is displayed.

    If the hero is changed please update the CSS below to reflect the aspect ratio of the new image
  */
  let aspectRatio = css`
    @media ${breakpointMobileExtended} {
      aspect-ratio: 1.637;
    }
  `;
  let mobileBackground = shouldUseSmallMobileBG
    ? backgroundMobileHM
    : backgroundMobile;
  if (isIntl()) {
    mobileBackground = backgroundMobileIntl;
    aspectRatio = css`
      @media ${breakpointMobileExtended} {
        aspect-ratio: 1.46;
      }
    `;
  }

  const height = css`
    height: calc(100% - ${isHolidayPromotion() ? "192px" : "100px"});
  `;

  return (
    <picture
      css={{
        width: "100%",
        borderBottomLeftRadius: 25,
      }}
    >
      <source
        media={`(max-width: ${breakpointMobileExtendedPixels})`}
        type="image/jpeg"
        srcSet={mobileBackground}
      />
      <source
        media={`(min-width: ${breakpointMobileExtendedPixels})`}
        type="image/jpeg"
        srcSet={isIntl() ? bgIntl : bg}
      />
      <img
        src={backgroundMobile}
        alt=""
        css={[backgroundImageStyles, aspectRatio, height]}
      />
    </picture>
  );
}
